import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function AboutUs() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "About InstaVivah",
    url: `${typeof window !== "undefined" ? window.location.origin : ""}/about`,
    description:
      "Learn about InstaVivah — India’s modern matrimonial biodata maker helping families create beautiful marriage biodatas and find trusted matches.",
  };

  return (
    <div>
      <SEO
        title="About Us"
        path="/about"
        description="InstaVivah helps Indian families create beautiful marriage biodatas and find trusted matches. Read our story, mission, and values."
        keywords="about InstaVivah, matrimonial biodata maker, marriage biodata website, indian matchmaking, biodata generator online"
        jsonLd={jsonLd}
      />
      <Navbar />

      <header className="sb-page-hero text-center">
        <div className="container">
          <div className="sb-kicker mb-2">Our Story</div>
          <h1>Built for the family album.</h1>
          <p>
            InstaVivah is a modern home for a very old tradition — helping
            Indian families craft beautiful marriage biodatas and find trusted,
            respectful matches online.
          </p>
        </div>
      </header>

      <main className="container py-5">
        <article className="sb-prose">
          <h2>Who we are</h2>
          <p>
            InstaVivah is a free-to-start matrimonial biodata maker and
            marriage profile platform, purpose-built for Indian communities.
            Whether you’re preparing a traditional biodata for the family
            elders, or creating a modern matrimonial profile to find your
            partner — we make the process quick, private and beautiful.
          </p>

          <h2>Our mission</h2>
          <p>
            Marriage decisions are among the most important a family will ever
            make. Our mission is to bring dignity, privacy, and thoughtful
            design to that journey. No spam. No surprise fees. No pressure.
            Just a calm, elegant tool your parents will also love using.
          </p>

          <h2>What makes InstaVivah different</h2>
          <ul>
            <li>
              <strong>Single source of truth.</strong> One profile powers both
              your printable biodata and your matrimonial profile — no
              double-entry, no drift.
            </li>
            <li>
              <strong>Heirloom-quality templates.</strong> Classic, Modern and
              Royal designs suitable for both family sharing and formal print.
            </li>
            <li>
              <strong>No signup to download.</strong> Guests can build a
              biodata and export PDF/DOCX before ever creating an account.
            </li>
            <li>
              <strong>Privacy first.</strong> Your phone and address stay
              hidden until you personally approve a connection.
            </li>
          </ul>

          <h2>Trust &amp; safety</h2>
          <p>
            Every profile you interact with is a real registered user. Photos,
            contact information and personal details are never shared publicly
            — only summary attributes (name, age, city, education, occupation)
            are visible on public browse. See our{" "}
            <Link to="/privacy">Privacy Policy</Link> and{" "}
            <Link to="/refund">Refund Policy</Link> for full details.
          </p>

          <h2>Get started</h2>
          <p>
            Ready to try it? <Link to="/biodata/build">Build a free biodata</Link>
            {" "}in under 5 minutes, or{" "}
            <Link to="/browse">browse public profiles</Link>. Questions?{" "}
            <Link to="/contact">Reach out</Link> — we reply within one business
            day.
          </p>
        </article>
      </main>

      <Footer />
    </div>
  );
}
